import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import MinimalLayout from 'layouts/MinimalLayout';
import AuthGuard from './guard/auth-guard';

// login option 3 routing
const SamplePage = Loadable(lazy(() => import('pages/SamplePage')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = [
    {
        path: '/',
        element: (
            <AuthGuard>
                <MinimalLayout />
            </AuthGuard>
        ),
        children: [
            {
                path: '/auth-sample-page',
                element: <SamplePage />
            }
        ]
    }
];

export default AuthenticationRoutes;
